// extracted by mini-css-extract-plugin
export default {"allWorkflowsContainer":"kKcJT8"};